(function () {
    'use strict';

    angular
        .module('sod.helper')
        .factory('customDropdownButtonService', customDropdownButtonService);

    function customDropdownButtonService(lodash) {
        var state = [];
        return {
            createReference: createReference,
            closeOthers: closeOthers,
            closeAll: closeAll,
            destroy: destroy,
            getState: function() {
                return state;
            },
        };

        function createReference(ref) {
            ref.id = new Date().getTime();
            state.push(ref);
            return ref.id;
        }

        function closeOthers() {

        }

        function closeAll() {
            state.map(function(item) {
                var func = lodash.get(item, 'close', function() {});
                func();
            });
        }

        function destroy(id) {
            lodash.remove(state, { id: id });
        }
    }
})();